import React, { useState } from 'react';
import useProgressSocket from '../../hooks/useProgressSocket';

/**
 * Lista de peritajes en curso con su % de completado (WP4).
 *
 * - Se actualiza en tiempo real por WebSocket (con respaldo por polling).
 * - Al hacer clic en un peritaje se despliega el desglose de secciones.
 * - `office` filtra por sede; `displayMode` estiliza para pantalla grande.
 */
export default function InProgressList({
  office = null,
  title = 'Peritajes en curso',
  displayMode = false,
}) {
  const [items, setItems] = useState([]);
  const [expanded, setExpanded] = useState(null);

  const { connected } = useProgressSocket({
    office,
    onMessage: (msg) => {
      if (msg && msg.type === 'progresslist') setItems(msg.data || []);
    },
  });

  return (
    <div className={`card ${displayMode ? 'border-0 shadow-none' : ''}`}>
      <div className="card-header d-flex justify-content-between align-items-center">
        <h3 className={`mb-0 ${displayMode ? 'h4' : 'h6'}`}>{title}</h3>
        <span className={`badge ${connected ? 'bg-success' : 'bg-secondary'}`}>
          {connected ? 'En vivo' : 'Actualizando'}
        </span>
      </div>
      <div className="list-group list-group-flush">
        {items.length === 0 && (
          <div className="list-group-item text-muted">Sin peritajes en curso</div>
        )}
        {items.map((item) => (
          <div className="list-group-item" key={item.inspection_id}>
            <button
              type="button"
              className="btn btn-link text-start w-100 d-flex justify-content-between align-items-center text-decoration-none p-0"
              onClick={() => setExpanded(
                expanded === item.inspection_id ? null : item.inspection_id
              )}
            >
              <span>
                <strong className={displayMode ? 'h5' : ''}>{item.placa}</strong>{' '}
                <span className="text-muted small">#{item.inspection_number}</span>{' '}
                <span className="text-muted small">{item.service_name}</span>
                {item.office_name && (
                  <span className="text-muted small"> · {item.office_name}</span>
                )}
              </span>
              <span style={{ minWidth: 130 }} className="text-end">
                <span className="fw-bold">{item.percentage}%</span>
                <span className="progress d-block mt-1" style={{ height: 8 }}>
                  <span
                    className="progress-bar"
                    role="progressbar"
                    aria-valuenow={item.percentage}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: `${item.percentage}%` }}
                  />
                </span>
              </span>
            </button>

            {expanded === item.inspection_id && (
              <ul className={`list-unstyled mt-2 mb-0 ${displayMode ? '' : 'small'}`}>
                {item.sections.map((section) => (
                  <li
                    key={section.code}
                    className={`d-flex justify-content-between py-1 ${
                      section.completed ? 'text-success' : 'text-muted'
                    }`}
                  >
                    <span>
                      {section.completed ? '✓' : '○'} {section.label}
                    </span>
                    <span>
                      {section.filled}/{section.expected}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
